import { Box } from "@mui/material";
import { DotLegalMultiSelect, DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { usePlanContext } from "../../auth/planProvider/PlanProvider";
import { PurpleLockIcon } from "@common/icons";
import PlanInputFieldWrapper from "../../plan/planInputFieldWrapper/PlanInputFieldWrapper";
import ActivityFormBox from "./ActivityFormBox";
import { ActivityPeopleSectionProps, useActivityPeopleSection } from "./ActivityPeopleSection.hooks";
import { useActivityFormStyles } from "./ActivityForm.styles";

function ActivityPeopleSection(props: ActivityPeopleSectionProps) {
    const { translateString } = useTranslation();
    const { platformFeatures } = usePlanContext();
    const styles = useActivityFormStyles();
    const {
        selectableResponsibles,
        selectableAssignees,
        usersLoading,
        approvalOptions,
        assigneesPlaceholder,
        showResponsibleError,
        onResponsibleChange,
        onAssigneesChange,
        onApprovalChange,
    } = useActivityPeopleSection(props);

    return (
        <ActivityFormBox title={translateString("activityFormPeople")} startsWithFieldLabel>
            <Box sx={styles.twoColumns}>
                <DotLegalSelect
                    label={translateString("responsible")}
                    toolTipText={translateString("responsibleForTaskTooltip")}
                    options={selectableResponsibles}
                    isLoading={usersLoading}
                    selectedItem={props.model.responsible}
                    onChange={onResponsibleChange}
                    placeholder={""}
                    noOptionsLabel={translateString("noOptions")}
                    disabled={props.readOnly}
                    errorText={showResponsibleError ? translateString("annualWheelDataTaskResponsibleError") : undefined}
                    useFixedLabel
                />
                <DotLegalMultiSelect
                    label={translateString("assignee")}
                    toolTipText={translateString("annualWheelActivityAssignee")}
                    options={selectableAssignees}
                    isLoading={usersLoading}
                    chosenOptions={props.model.assignees}
                    onChange={onAssigneesChange}
                    placeholder={assigneesPlaceholder}
                    noOptionsLabel={translateString("noOptions")}
                    disabled={props.readOnly}
                    useFixedLabel
                />
            </Box>

            <PlanInputFieldWrapper hasAccess={platformFeatures.signOff} hoverText={translateString("upgradePrivacyPlanToday")}>
                <DotLegalSelect
                    label={translateString("approval")}
                    toolTipText={translateString("doesTasksNeedApproval")}
                    options={approvalOptions}
                    isLoading={usersLoading}
                    selectedItem={props.model.approval.toString()}
                    onChange={onApprovalChange}
                    placeholder={""}
                    noOptionsLabel={translateString("noOptions")}
                    disableClearable
                    disableSearch
                    disabled={props.readOnly || !platformFeatures.signOff}
                    icon={!platformFeatures.signOff ? PurpleLockIcon : undefined}
                    useFixedLabel
                />
            </PlanInputFieldWrapper>
        </ActivityFormBox>
    );
}

export default ActivityPeopleSection;
